import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { LocationState } from "@/redux/slice/location/types/LocationState";
import { ThunkResolvedStatus } from "@/libs/enum/ThunkResolvedStatus";
import fetchPatientAddressList from "@/redux/slice/location/thunks/fetchPatientAddressList";
import addressListAdapter from "@/redux/slice/location/adapters/addressList";

const fetchUpdatedAddressListBuilder = (builder: ActionReducerMapBuilder<LocationState>): void => {
  builder
    .addCase(fetchPatientAddressList.pending, (state) => {
      state.thunkStatus.addressListUpdated = ThunkResolvedStatus.pending;
      state.isAddressListUpdated = false;
    })
    .addCase(fetchPatientAddressList.fulfilled, (state, action) => {
      const addressList = action?.payload;
      const addresses = addressList?.reverse().filter(({ id }) => id);
      addressListAdapter.setAll(state.addressList, addresses);
      state.thunkStatus.addressListUpdated = ThunkResolvedStatus.fulfilled;
      state.isAddressListUpdated = true;
    })
    .addCase(fetchPatientAddressList.rejected, (state) => {
      state.thunkStatus.addressListUpdated = ThunkResolvedStatus.rejected;
      state.currentAddressId = "";
      state.isAddressListUpdated = true;
    });
};

export default fetchUpdatedAddressListBuilder;
